import { render, staticRenderFns } from "./ParticleEffects.vue?vue&type=template&id=3d0e771e&scoped=true&"
import script from "./ParticleEffects.vue?vue&type=script&lang=js&"
export * from "./ParticleEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e771e",
  null
  
)

export default component.exports